export default __webpack_public_path__ + "static/media/amazon.40ed6355.svg";